/* global $ */

import forEach from 'lodash/forEach';

const CardStatistics = {
  create(node, options) {
    this.node = node;
    this.options = options;

    this.$dateSelect = $(this.node).find('.js-card-statistics-select');
    this.$fromDate = $(this.node).find('.js-card-statistics-from');
    this.$toDate = $(this.node).find('.js-card-statistics-to');
    this.$output = $(this.node).find('.js-card-statistics-output');

    this.cardTemplate = $(this.node).find('.js-card-statistics-template').html();

    this.createListeners();

    this.run = () => {
      this.fetch(this.getDates())
        .then(this.outputCards.bind(this));
    };

    this.run();
  },

  createListeners() {
    this.$dateSelect.on('change', () => {
      this.changeQuickDate();
    });

    this.$fromDate.add(this.$toDate).on('change', () => {
      this.run();
    });
  },

  changeQuickDate() {
    const dateRange = this.$dateSelect.val();
    let start;
    let end;

    if (dateRange.indexOf('/') >= 0) {
      [start, end] = dateRange.split('/');
    } else {
      start = dateRange;
      end = dateRange;
    }

    this.outputToDatepickers(start, end);
    this.run();
  },

  outputToDatepickers(start, end) {
    this.$fromDate.val(start);
    this.$toDate.val(end);
  },

  getDates() {
    return {
      from: this.$fromDate.val(),
      to: this.$toDate.val(),
    };
  },

  fetch(dates) {
    return window.axios.get(this.options.cardStatisticsApi, { params: dates })
      .then(data => data.data)
      .catch(() => {
        // console.error(err);
      });
  },

  outputCards(data) {
    const cards = [];

    forEach(data, (val, key) => {
      const card = this.cardTemplate
        .replace('##title##', key)
        .replace('##stat##', val);

      cards.push(card);
    });

    this.$output.html(cards.join(''));
  },
};

export default CardStatistics;
